import * as React from 'react';
import '../css/copy-to-clipboard.sass';
import StaticElementButton from './StaticElementButton';

interface CopyToClipboardProps {
  textToCopy: string;
  theme: 'day' | 'night';
}

export default function CopyToClipboard(props: CopyToClipboardProps) {
  const handleClick = () => {
    if (!navigator.clipboard) {
      return;
    }
    navigator.clipboard.writeText(props.textToCopy);
  };
  return (
    <StaticElementButton
      name="clipboard"
      id="clipboard"
      label="Clipboard"
      type="div"
      onClick={handleClick}
      handleKeyDown={handleClick}
      className={`clipboard ${props.theme}`}
    />
  );
}
